import { useAuthStore } from 'core/store/auth';
import { useEffect, useState } from 'react';
import { isAdmin } from 'ui/helpers/users';

import CreditCardIcon from '@mui/icons-material/CreditCard';
import { Box, Button, CardContent, Dialog, DialogActions, DialogContent, Typography, useMediaQuery, useTheme } from '@mui/material';

const DEFAULT_POPUP_ID = 'Paymentus2GlobalInfoPopup';

const TEXT = (
  <>
    Wall Check will be down for scheduled maintenance between 6:00 PM, Friday, July 10, 2026, through 9:00 PM, Sunday,
    July 12, 2026. Thanks for your patience as we perform some system upgrades.
    {/* Thank you for your use of the Department of Buildings (DOB) online payment system for Wall Check. The District
    government has migrated to JP Morgan Chase as its exclusive online payment processor. This will result in a charge
    for card payments.
    <br />
    <br />
    Effective Monday, May 19, 2025, card payments will see an additional convenience fee, representing a percentage of
    the transaction amount. You will see the fee under the line item “convenience fee.”
    <br />
    <br />
    You can avoid this new convenience fee by making an electronic check payment using eCheck; note that if you are
    using a commercial deposit account rather than a personal account, you may be required to provide DOB’s new merchant
    identifier (0000408976).
    <br />
    <br />
    Thank you for your understanding as we make this change to the customer service experience. If you have any
    questions, please contact DOB at <a href="mailto:dob@dc.gov">dob@dc.gov</a>.
    <br />
    <br />
    <Box sx={{ textAlign: 'left' }}>
      Cordially,
      <br />
      DOB’s Customer Affairs Team
    </Box> */}
  </>
);

interface AppMessageOverlayProps {
  id?: string;
}

export default function AppMessageOverlay(props: AppMessageOverlayProps) {
  const { id = DEFAULT_POPUP_ID } = props;

  const { currentUser } = useAuthStore();
  const isUserAdmin = isAdmin(currentUser?.userProfile.roles || []);

  const [open, setOpen] = useState(localStorage.getItem(id) !== 'true' && !isUserAdmin);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const onCancel = () => {
    setOpen(false);
    localStorage.setItem(id, 'true');
  };

  const handleClick = () => {
    onCancel();
  };

  useEffect(() => {
    if (isUserAdmin) {
      onCancel();
    }
  }, [isUserAdmin]);

  const handleCancel = () => {
    onCancel();
  };

  return (
    <>
      {open && (
        <Dialog
          maxWidth="md"
          open={open}
          // onClose={handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <CardContent>
              {!matches && (
                <Box mb={1} fontSize="10rem" display="flex" justifyContent="center">
                  <CreditCardIcon
                    sx={{
                      fontSize: '8rem',
                      color: theme.palette.primary.main,
                    }}
                  />
                </Box>
              )}
              <Box textAlign="center">
                <Typography variant="h2" sx={{ fontSize: '2.8rem' }}>
                  Dear Customer
                </Typography>
              </Box>
              <Box fontSize="2rem" textAlign="center">
                <p>{TEXT}</p>
              </Box>
            </CardContent>
          </DialogContent>
          <DialogActions
            disableSpacing
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleClick();
              }}
            >
              Ok I understand
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
